import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListStateResponse } from '../../responses/user/list-state.response';

@Injectable({
  providedIn: 'root'
})
export class HealthUnitStateService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }
  
  public getStateByInitials(stateInitials: string): Observable<ListStateResponse> {

    let uri = `HealthUnitState/stateUf/${stateInitials}`;

    return this.httpClient.get<ListStateResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
  
  public getAllStates(): Observable<ListStateResponse> {

    let uri = `HealthUnitState`;

    return this.httpClient.get<ListStateResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
    
    